import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BdbRequest } from '@npm-bbta/bbog-cm-auth-lib';
import { environment } from '../../../environments/environment';
import { BdbEncryptService } from '@npm-bbta/bbog-cm-auth-lib';
import { SandboxRequestService } from './sandbox/sandbox-request.service';
import { BdbRequestService } from './bdb-request.service';

@Injectable()
export class ParticipantService {

    constructor(
        private bdbRquest: BdbRequest,
        private bdbEncryptService: BdbEncryptService,
        private readonly sandboxRequestService: SandboxRequestService,
        private readonly bdbRequestService: BdbRequestService
    ) { }

    getParticipantState(identityNumber: any): Observable<any> {
        const cipher = this.getEncryptData(identityNumber);
        return this.bdbRquest.requestPost(environment.endpointCifin + 'authentication/cifin/participant-state', {
            documentNumberCipher: cipher
        });
    }

    async getParticipantStateWithSandboxV3(identityNumber: any) {
        const documentNumber = identityNumber;
        const documentType = 'CC';
        const savedIdentifyTypeAuthentication = '0';
        const optionCustomerTypeSelected = parseInt(savedIdentifyTypeAuthentication, 10);
        const newHeaders = this.bdbRequestService.getStandardizedHeaders(documentType, documentNumber);
        console.log(':: Init participant with sandbox ::');
        const url = environment.authenticatorEndpointSandboxV3 + '/authentication/cifin/V2/participant-state-web';
        const body = {
          documentNumber,
          documentType,
          optionCustomerTypeSelected
        };
        Object.assign(newHeaders, {'content-type': 'application/json'});
        delete newHeaders['Content-Type'];
        console.log(':: Participant with sandbox headers ', {headers: newHeaders});
        const result = await this.sandboxRequestService.requestPostSandbox(url, body, newHeaders, true);
        return { body: result.body.participantResult, status: result.status };
      }


    getEncryptData(identityNumber: any) {
        return this.bdbEncryptService.encrypt(identityNumber);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/participant.service.ts